import { render, staticRenderFns } from "./CampaignPermissionsAdd.vue?vue&type=template&id=fcc873c4&"
import script from "./CampaignPermissionsAdd.vue?vue&type=script&lang=ts&"
export * from "./CampaignPermissionsAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports